var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fm-table-new',{ref:"table",attrs:{"columns":_vm.columnList,"border":"row","data-list":_vm.content,"stripe":false,"size":"small","emptyPlaceholder":"-"},scopedSlots:_vm._u([{key:"actions",fn:function({ row }){return _c('table-actions',{attrs:{"data":_vm.tableActions,"row":row},on:{"table-action":_vm.tableAction}})}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }